import { DocumentType } from '@bulthaup/api/db';
import { Button, Group, Stack, Text } from '@mantine/core';
import { IconEye } from '@tabler/icons-react';
import { reverse } from 'lodash';

import { DeliveryOrderButton } from '../../../-components/delivery-order/delivery-order-button';
import { RouterOutput } from '../../../../../../../services/trpc';
import { getUTDocumentUrl } from '../../../../../../../services/upload';
import { formatDate } from '../../../../../../../utils/format';

export function DeliveryOrderSection({
  project,
}: {
  project: NonNullable<RouterOutput['projects']['get']>;
}) {
  const deliveryOrderDocuments = project.documents.filter(
    document => document.type === DocumentType.DELIVERY_ORDER,
  );
  // console.log(DocumentType.DELIVERY_ORDER, deliveryOrderDocuments);

  return (
    <Stack>
      <Group>
        <DeliveryOrderButton project={project} />
      </Group>
      {deliveryOrderDocuments.length > 0 && (
        <Stack>
          {reverse(deliveryOrderDocuments).map(document => (
            <Group key={document.id} align="center" justify="space-between">
              <Stack gap={0}>
                <Group>
                  <Text>Ordre n°{document.version}</Text>
                </Group>
                <Text c="dimmed" size="sm" truncate style={{ flex: 1 }}>
                  le {formatDate(document.createdAt)}
                </Text>
              </Stack>
              <Button
                leftSection={<IconEye size={16} />}
                variant="outline"
                onClick={() => {
                  window.open(getUTDocumentUrl(document.utFileKey), '_blank');
                }}
              >
                Voir
              </Button>
            </Group>
          ))}
        </Stack>
      )}
    </Stack>
  );
}
